// Get the lang only for production environment, because we it's the only place that is used for Drupal embed.

let lang = '';
if (window && window['drupalSettings'] && window['drupalSettings']['path']) {
  const drupalSettings = window && window['drupalSettings'] ? window['drupalSettings'] : null;
  lang = drupalSettings['path']['currentLanguage'];
  lang = lang !== 'en' ? `/${lang}/` : ``;
}

export const environment = {
  production: true,
  gtm_tracking_code: "UA-44483718-2",
  api_url: 'https://api.worldarchery.sport',
  priceForPrecision: {
    apiContentCategories: 'PRECISIONPRIZECATEGORIES',
    apiContentData: 'PRECISIONPRIZERANKINGS',
    apiYearData: 'SERIES'
  },
  drupal_api: "",
  photosAPI: lang + "api/photos",
  photoEventsApi: lang + "api/events-photos/athlete_id",
  competitions_gallery: lang + "api/competition-galleries/competition_id",
  videosCountAPI: "api/athlete/Id/video-status",
  extranetUrl: "//extranet.worldarchery.sport",
  intranetUrl: "",
  assetsBasePath: "/sites/all/modules/custom/wa_angular/includes/plugins/content_types/calendar",
  athlete_biography: lang + "api/editorial/athlete/bio/athlete_id",
  editorial_quotes: lang + "api/editorial/quotes",

  news_api: {
    continental_association: lang + "api/continental-associations/replace_id/news",
    member: lang + 'api/members/replace_id/news',
    members: lang + 'api/members/news',
    athletes_spotligth: lang + 'api/athletes/news',
    athlete_news: lang + "api/athletes/news/athlete_id",
    athlete_news_teaser: lang + "api/athlete/news/teaser/athlete_id",
    competition_news_teaser: lang + "api/competition/news/teaser/competition_id",
    competition_day_review_new: lang + "api/competition/day_review_news/teaser/competition_id",
    competition_news_athlete_teaser: lang + "api/competition/news/teaser/competition_id/athlete/athlete_id",
    indoor: lang + "api/indoor/news",
    continental_association_teaser: lang + "api/continental-association/news/teaser/replace_id",
    member_association_teaser: lang + "api/member-association/news/teaser/replace_id",
    world_records: lang + "api/world-records/news",
    world_ranking: lang + "api/world-ranking/news",
  },
  competition: {
    tofficial: lang + "tservices/official/competition_id",
    editorial_information: lang + "api/editorial/competition/info/competition_id"

  },
  youtube_api_url: `/youtube/search`,
};
